<div class="widget-container">
    <div class="dropdown-container" *ngIf="isTrendDropdownShow" #dropdownContainer>
        <div class="dropdown-button" (click)="onButtonClick()">
            <span class="dropdown-text">{{ selectedOption }}</span>
            <span class="dropdown-arrow" [ngStyle]="{ backgroundColor: isDropdownOpen ? '#3777FF33' : '' }">
                <img [ngStyle]="{
                    filter: isDropdownOpen ? 'brightness(0) saturate(100%) invert(26%) sepia(89%) saturate(1954%) hue-rotate(204deg) brightness(98%) contrast(101%)' : null,
                    transform: isDropdownOpen ? 'rotate(180deg)' : null
                }" src="assets/images/menu-down-dark.svg">
            </span>
        </div>
        <div class="dropdown-content" *ngIf="isDropdownOpen">
            <ul>
                <li *ngFor="let option of options" (click)="onOptionClick(option)" [ngClass]="{'selected': selectedField === option.trend_type}">
                    <span class="dropdown-text">{{option.name}}</span>
                </li>
            </ul>
        </div>
    </div>
    <div ngbTooltip="Absolute Bar Chart" class="absolute-chart-button" [ngClass]="{'active': isAbsoluteChartActive}" *ngIf="isAbsoluteChartShow" (click)="toggleGraphScale('absoluteChart')">
         <span><img class="opacity" src="assets/images/bar_chart.svg"></span>
    </div>
    <div ngbTooltip="Percentage Bar Chart" class="percentage-chart-button" [ngClass]="{'active': isPercenttageChartActive}" *ngIf="isPercenttageChartShow" (click)="toggleGraphScale('percentageChart')">
       <span><img class="opacity" src="assets/images/bar-chart-percent.svg"></span>
    </div>
    <div class="download-button" *ngIf="isDownloadButtonShow" (click)="onDownloadButtonClick($event)">
        <span><img class="opacity" src="assets/images/download.svg"></span>
    </div>
    <div class="fullscreen-button" *ngIf="isFullScreenButtonShow" (click)="onFullscreen($event)">
        <span [ngStyle]="{ 'margin-top': isFullscreen ? '-3px' : '0px' }"><img [src]="isFullscreen ? 'assets/images/fullscreen-exit.svg' : 'assets/images/fullscreen.svg'"></span>
    </div>
</div>